import { withAuthenticator } from "@aws-amplify/ui-react";
import React from 'react';
import { Toaster } from "react-hot-toast";

import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { LayoutProvider } from "./context/LayoutContext";
import Content from "./Content";

const AdminLayout = ({ user, children }) => {
  return (
    <LayoutProvider user={user}>
        <Toaster />
        <Header />
        <Sidebar />
        <Content>{children}</Content>
        <Footer />
    </LayoutProvider>
  );
};

export default withAuthenticator(AdminLayout);
